import { render, staticRenderFns } from "./AgeReminder.vue?vue&type=template&id=86b475c0&scoped=true"
import script from "./AgeReminder.vue?vue&type=script&lang=js"
export * from "./AgeReminder.vue?vue&type=script&lang=js"
import style0 from "./AgeReminder.vue?vue&type=style&index=0&id=86b475c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b475c0",
  null
  
)

export default component.exports